import script from "./PublicPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicPage.vue?vue&type=script&setup=true&lang=js"

import "./PublicPage.vue?vue&type=style&index=0&id=64404371&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64404371"]])

export default __exports__